import PromoAsCheckbox from 'components/checkout/caap/payment/paymentlist/PromoAsCheckbox';
import PromoAsRadio from 'components/checkout/caap/payment/paymentlist/PromoAsRadio';
import PurchasePromos from 'components/checkout/caap/payment/paymentlist/PurchasePromos';
import ContentBox from 'components/checkout/caap/ContentBox';
import {
  isGiftCardOnlyCart,
  isNonRetailOnlyCart
} from 'helpers/CheckoutUtils';
import { paymentListHeader } from 'styles/components/checkout/caap/payment/paymentlist/paymentlistitemheaderdesktop.scss';

const PromoSection = componentParams => {
  const {
    balance,
    cartType,
    eligibleBalances,
    onEditPaymentClick,
    onPaymentSelected,
    onUsePromoBalanceClick,
    selectedPaymentId,
    showAsRadio,
    usePromoBalance
  } = componentParams;

  if (hasNoBalances(eligibleBalances)) {
    return null;
  }

  // TODO: https://github01.zappos.net/mweb/marty/issues/3357
  // can remove this once the balance is returned
  if (isGiftCardOnlyCart(cartType) && hasOnlyCouponBalance(eligibleBalances)) {
    return null;
  }

  // can't apply promo or gc balances to GC Only Carts
  // TODO: https://github01.zappos.net/mweb/marty/issues/3357
  // remove the hasOnlyGCBalance check once coupon balance returned
  if (isGiftCardOnlyCart(cartType) && hasOnlyGCBalance(eligibleBalances)) {
    return (
      <ContentBox isSolo={true} isNonRadio={true}>
        <PurchasePromos eligibleBalances={eligibleBalances} />
      </ContentBox>
    );
  }

  // can't apply gc balances to mixed carts
  if (isNonRetailOnlyCart(cartType) && hasOnlyGCBalance(eligibleBalances)) {
    return (
      <ContentBox isSolo={true} isNonRadio={true}>
        <PurchasePromos eligibleBalances={eligibleBalances} />
      </ContentBox>
    );
  }

  if (showAsRadio) {
    return (
      <>
        { makeYourBalanceText() }
        <PromoAsRadio
          balance={balance}
          cartType={cartType}
          eligibleBalances={eligibleBalances}
          onEditPaymentClick={onEditPaymentClick}
          onPaymentSelected={onPaymentSelected}
          selectedPaymentId={selectedPaymentId}
        />
      </>
    );
  } else {
    return (
      <>
        { makeYourBalanceText() }
        <PromoAsCheckbox
          balance={balance}
          cartType={cartType}
          eligibleBalances={eligibleBalances}
          usePromoBalance={usePromoBalance}
          onUsePromoBalanceClick={onUsePromoBalanceClick}
        />
      </>
    );
  }
};

const makeYourBalanceText = () => <div className={paymentListHeader}>
    Your available balance
</div>;

const hasNoBalances = ({ combinedDiscountBalance }) => combinedDiscountBalance === 0;

const hasOnlyGCBalance = ({ combinedDiscountBalance, gcBalance }) => gcBalance && combinedDiscountBalance === gcBalance;

const hasOnlyCouponBalance = ({ combinedDiscountBalance, couponBalance }) => couponBalance && combinedDiscountBalance === couponBalance;

export default PromoSection;
